export default __webpack_public_path__ + "static/media/bs-secondary-coupe.26bb84a2.svg";